import './css/style.css';
import $ from 'jquery';
import 'jquery.cookie';
import { fetchDocuments, fetchNewsDocuments, fetchDocumentsAll } from "./commons";

$(document).ready(function () {


    /****
     * ####################################
     * 2021/7/27 add common header footer
     * ##################################
     * start
     **/
    /*** start ****/
    let current_url = document.location.toString();

    if (current_url.indexOf("/au/") >= 0) {
        return
    }

    $("#common-header").load("./components/header.html", function () {
        externelListener();
    });
    $("#common-footer").load("./components/footer.html", function () {
        $('#slidershow').css("visibility", "visible");
    });

    if ($('#cookieLayer')[0]) {
        cookieLayerInit();
    } else if ($('#disclaimer')[0]) {
        disclaimerInit();
    }
    /*** end ****/


    let queryParams = {};
    fetchDocuments(queryParams);
    fetchNewsDocuments(queryParams);

    var unChecked = 0;
    var SallLcboxCheckDisabled = $("input:checkbox");
    for (var j = 0; j < SallLcboxCheckDisabled.length; j++) {
        if (SallLcboxCheckDisabled[j].checked) {
            unChecked++;
        }
    }
    if (unChecked == 0) {
        document.getElementById("SHsearch").disabled = false;
        $("input:checkbox[id='SallLcbox']").prop("checked", true);
    }
    document.getElementById("SgliconCheck").disabled = true;
});

$('#SallLcbox').click(function (e) {
    if (e.target.checked) {
        //window.location.reload();
        document.getElementById("SHsearch").disabled = false;
        var SallLcboxCheck = $("input:checkbox");
        for (var i = 1; i < SallLcboxCheck.length; i++) {
            $("input:checkbox[id='" + SallLcboxCheck[i].id + "']").prop("checked", false);
        }
        /*for (var i = 0; i < 28; i++) {
            if(!isEmpty(languageFilters[i])){
                languageFilters[i]="";
            }
        }*/
        //alert(languageFilters);
        //alert(productFilters);
        let queryParams = {};
        fetchDocumentsAll(queryParams);
    } else {
        var unChecked = 0;
        var SallLcboxCheckDisabled = $("input:checkbox");
        for (var j = 0; j < SallLcboxCheckDisabled.length; j++) {
            if (SallLcboxCheckDisabled[j].checked) {
                unChecked++;
            }
        }
        if (unChecked == 0) {
            document.getElementById("SHsearch").disabled = true;
        }
    }
});

$('#Sglicon').click(function () {
    var tmp = $("#SBrandNProductC").val();
    if (isEmpty(tmp)) {
        return;
    }
    var $form = $('form[name="topForm"]');
    $form.submit();
});

$("#SBrandNProductC").on("change keyup paste", function () {
    var currentVal = $(this).val();
    if (currentVal == "") {
        document.getElementById("SgliconCheck").disabled = true;
    } else {
        document.getElementById("SgliconCheck").disabled = false;
    }
});

$('#SHsearch').click(function () {

    var SallLcboxCheck = $("input:checkbox");
    var unChecked = 0;
    for (var i = 0; i < SallLcboxCheck.length; i++) {
        if (SallLcboxCheck[i].checked) {
            unChecked++;
        }
    }
    if (unChecked == 0) return;
    var $form = $('form[name="searchForm"]');
    $form.submit();
    //$("input:checkbox[id='SallLcbox']").prop("checked", true);
});

$('#FTproductsAZ').click(function () {
    var $form = $('form[name="BrandNameForm"]');
    $form.submit();
});

$('.cancelAction').click(function () {
    // event.preventDefault();
    deleteCookie('website');
    window.location.reload();
});

$('.doAction').click(function () {
    // setCookieAndRedirect();
    // window.location.reload(true);
    $(".popup").hide();
    setCookie('website', 'Labeling');
    $(".popupCookie").show();
});

$('#popupCookiesShow').click(function () {
    $(".popupCookie").hide();
});

$('.doActionCookie').click(function () {
    $(".popupCookie").hide();
});

$('#acceptTheCookiePolicy').click(function () {
    setCookie('websitePop', 'CookiePolicy');
    $("#hayabusacookiedisclaimer").hide();
});

$('.btnBack').click(function () {
    //window.open('about:blank','_self').close();
    window.history.back();
});

var $box, $confirm, answer;
$box = $("#disclaimerBox");
$confirm = $(".confirmBtn", $box);

function leavePageConfirm() {
    $box.fadeOut(150);
    $(".module-sticky-footer").show();
    $(".popup").show();
}

$confirm.on("click", "a", function () {
    answer = $(this).attr("class");
    leavePageConfirm(answer);

    return false;
});

$('#SHreadAllNews').click(function () {
    $("li.hidden").attr('class', 'news-item');
    $("#SHreadAllNews").attr('class', 'hidden');
    $("#closeNews").attr('class', '');
});

$('#FTNews').click(function () {
    $("li.hidden").attr('class', 'news-item');
    $("#SHreadAllNews").attr('class', 'hidden');
    $("#closeNews").attr('class', '');
});

$('#closeNews').click(function () {
    /*var limit = $("#SHLatestNews").children();
    for (var i = 3; i <= limit.length; i++) {
        $("#SHLatestNews > li:nth-child("+i+")").attr('class','hidden');
    }*/
    let queryParams = {};
    fetchNewsDocuments(queryParams);
    $("#closeNews").attr('class', 'hidden');
    $("#SHreadAllNews").attr('class', '');
});

var linkName = "";
$('#HDterumoGlobal').click(function (e) {
    $(".module-sticky-footer").show();
    $(".popupLeave").show();
    linkName = e.target.id;
})

$('#HDcontact').click(function (e) {
    $(".module-sticky-footer").show();
    $(".popupLeave").show();
    linkName = e.target.id;
})

$('#FTcontact').click(function (e) {
    $(".module-sticky-footer").show();
    $(".popupLeave").show();
    linkName = e.target.id;
})

$('.cancelActionLeave').click(function () {
    $(".module-sticky-footer").hide();
    $(".popupLeave").hide();
});

$('.doActionLeave').click(function () {
    $(".module-sticky-footer").hide();
    $(".popupLeave").hide();
    if (linkName == "HDterumoGlobal") {
        location.href = "https://www.terumo.com/";
    } else {
        location.href = "https://www.terumo-europe.com/en-emea/contact";
    }
});

function setCookie(name, value) {
    var date = new Date();
    date.setTime(date.getTime() + 1000 * 60 * 60);
    //document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/';
    document.cookie = name + '=' + value + ';path=/';
}

//暫定対応
/*function getCookie(name) {
    var value = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return value? value[2] : null;
}*/

function deleteCookie(cookieName) {
    var expireDate = new Date();
    expireDate.setDate(expireDate.getDate() - 1);
    document.cookie = cookieName + "= " + "; expires=" + expireDate.toGMTString() + "; path=/";
}

function isEmpty(str) {
    if (typeof str == "undefined" || str == null || str == "")
        return true;
    else
        return false;
}

$(document).on('click', 'nav .tit', function () {
    if ($(this).hasClass('close')) {
        $(this).removeClass('close');
        $(this).next().slideDown('normal', function () { });
    } else {
        $(this).addClass('close');
        $(this).next().slideUp('normal', function () { });
    }
    return false;
});

//////外部サイト移動告知
function externelListener() {
    var href;
    var externalclose = function () {
        $('#external').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $(this).css({
                opacity: 1
            });
            $('html').removeClass('externalOpen');
        });
    };
    $('#external button.yes').on('click', function () {
        window.open(href, 'blank');
        externalclose();
        return false;
    });
    $('#external button.no').on('click', function () {
        externalclose();
        return false;
    });
    $('a[target="_blank"]').on('click', function () {
        href = $(this).attr('href');

        $('html').addClass('externalOpen');

        $('#external').css({
            opacity: 0
        }).animate({
            opacity: 1
        }, 'normal', function () {
        });

        return false;
    });
}

//////Cookie承認
function cookieLayerInit() {
    var cookieLayerclose = function () {
        $('#cookieLayer').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $(this).css({
                opacity: 1
            });
            $('html').removeClass('cookieLayerOpen');
        });
        // $('[data-role="policy"] .btnOk').hide();
    };

    var cookieOk = function () {
        $.cookie('cookieaccepted', 'true', { expires: 1, path: '/' });
        cookieLayerclose();
    };
    $('#cookieLayer button.yes').on('click', function () {
        cookieOk();
        disclaimerInit();
        return false;
    });

    if ($.cookie('cookieaccepted') === undefined) {
        $('html').addClass('cookieLayerOpen');

        $('#cookieLayer').css({
            opacity: 0
        }).animate({
            opacity: 1
        }, 'normal', function () {
        });
    } else {
        disclaimerInit();
    }
}

//////閲覧者確認
function professionalInit() {
    var professionalclose = function () {
        $('#professional').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $(this).css({
                opacity: 1
            });
            $('html').removeClass('professionalOpen');
        });
    };
    $('#professional button.yes').on('click', function () {
        $.cookie('hcppolicy', 'accepted', { expires: 1, path: '/' });
        professionalclose();
        // cookieLayerInit();
        return false;
    });
    $('#professional button.no').on('click', function () {
        $.cookie('hcppolicy', 'denied', { expires: 1, path: '/' });
        professionalclose();
        // cookieLayerInit();
        return false;
    });

    if ($.cookie('hcppolicy') === undefined) {
        $('html').addClass('professionalOpen');

        $('#professional').css({
            opacity: 0
        }).animate({
            opacity: 1
        }, 'normal', function () {
        });
    } else {
        // cookieLayerInit();
    }
}
/////免責画面
function disclaimerInit() {
    var disclaimerClose = function () {
        $('#disclaimer').css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $('html').removeClass('disclaimerOpen');
        });
    };
    $('#disclaimer .disclaimer-cont ul li .btnContinue').on('click', function () {
        disclaimerClose();
        $.cookie('disclaimer', 'true', { expires: 1, path: '/' });
        professionalInit();
        return false;
    });
    $('#disclaimer .disclaimer-cont ul li .btnBack').on('click', function () {
        console.log(document.referrer);
        if (window.opener) {
            window.close();
        } else if (document.referrer) {
            window.location.href = document.referrer;
        }
        return false;
    });

    if ($.cookie('disclaimer') === undefined) {
        $('html').addClass('disclaimerOpen');
        $('#disclaimer').css({
            opacity: 0
        }).animate({
            opacity: 1
        });
    } else {
        professionalInit();
    }
}

////////////////
$('.readMore').on('click', function () {
    var $parent = $(this).parent();
    if ($parent.hasClass('open')) {
        $parent.find('.storage').slideUp();
        $parent.removeClass('open');
        var top = $parent.offset().top;
        $('html,body').animate({
            scrollTop: top
        });
    } else {
        $parent.find('.storage').slideDown();
        $parent.addClass('open');
    }
    return false;
});
////トップリサイズ
var ontopresize = function () {
    var _display = $('header .headerInr .menu').css('display');
    if (_display === 'none') {
        var len = $('ul.vertical.products li').length;
        var col = Math.ceil(len / 3);
        var ht = 0;
        $('ul.vertical.products li').each(function () {
            if (ht < $(this).outerHeight()) {
                ht = $(this).outerHeight();
            }
        });
        $('ul.vertical.products').css({
            height: ht * col
        });
    } else {
        $('ul.vertical.products').css({
            height: ''
        });
    }
};
if ($('ul.vertical.products')[0]) {
    $(window).on('resize.products', ontopresize);
    ontopresize();
}
////検索結果リサイズ
var onresultresize = function () {
    var _display = $('header .headerInr .menu').css('display');
    if (_display === 'none') {
        $('.resultList .item .itemHead').each(function () {
            var $itemHead = $(this);
            var ht = 0;
            $itemHead.find('td').each(function () {
                var oh = $(this).outerHeight();
                if (ht < oh) ht = oh;
            });

            $itemHead.find('td').css({
                height: ht
            });
        });

    }
};
if ($('.resultList .item .itemHead')[0]) {
    $(window).on('resize.result', onresultresize);
    onresultresize();
}

/////////////////
var scrollTop = 0;
$(document).on('click', 'nav .navTit .btnClose', function () {
    $('nav').css({
        opacity: 1
    }).animate({
        opacity: 0
    }, 'normal', function () {
        $('html').removeClass('navOpen');
        $('html,body').scrollTop(scrollTop);
        scrollTop = 0;
        $('body').css({
            top: 0
        });
    });
    return false;
});
$('.btnFilter a').on('click', function () {
    if ($('html').hasClass('navOpen')) {
        $('html').removeClass('navOpen');
    } else {
        scrollTop = $('html,body').scrollTop();
        $('body').css({
            top: scrollTop * -1
        });
        $('html').addClass('navOpen');

        $('nav').css({
            opacity: 0
        }).animate({
            opacity: 1
        });
    }
    return false;
});

//////////////
$(document).on('click', 'header .headerInr .menu', function () {

    var $nav = $('header .headerInr .nav');

    if ($('html').hasClass('menuOpen')) {
        $nav.css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $('html').removeClass('menuOpen');
            $('html,body').scrollTop(scrollTop);
            scrollTop = 0;
            $nav.css({
                opacity: 1
            });
        });
    } else {
        scrollTop = $('html,body').scrollTop();
        $('html').addClass('menuOpen');
        $nav.css({
            top: $('header').outerHeight(),
            opacity: 0
        }).animate({
            opacity: 1
        });
    }
    return false;
});
/////////////
$('.resultHead .result dl dd').on('click', function () {
    if ($('header .headerInr .menu').css('display') === 'none') return false;
    var $next = $(this);
    $next.css({
        opacity: 1
    }).animate({
        opacity: 0
    }, 'normal', function () {
        $('html').removeClass('helpOpen');
        $next.removeClass('open');
        $('html,body').scrollTop(scrollTop);
        $('body').css({
            top: 0
        });
        scrollTop = 0;
    });

    return false;
});
$('.resultHead .result dl dt').on('click', function () {
    if ($('header .headerInr .menu').css('display') === 'none') return false;
    var $next = $(this).next();

    if ($('html').hasClass('helpOpen')) {
        $next.css({
            opacity: 1
        }).animate({
            opacity: 0
        }, 'normal', function () {
            $('html').removeClass('helpOpen');
            $next.removeClass('open');
            $('html,body').scrollTop(scrollTop);
            $('body').css({
                top: 0
            });
            scrollTop = 0;
        });
    } else {
        scrollTop = $('html,body').scrollTop();
        $next.addClass('open');
        $('html').addClass('helpOpen');
        $('body').css({
            top: scrollTop * -1
        });

        $next.css({
            opacity: 0
        }).animate({
            opacity: 1
        }, 'normal', function () {
        });
    }
    return false;
});


